import React from "react";

function EmptySuggestionsIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="820.16"
            height="780.81"
            data-name="Layer 1"
            viewBox="0 0 820.16 780.81"
            style={{maxWidth: "100%", height: 150}}
        >
            <defs>
                <linearGradient
                    id="a"
                    x1="539.63"
                    x2="539.63"
                    y1="734.6"
                    y2="151.19"
                    gradientTransform="translate(-3.62 1.57)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stopColor="gray" stopOpacity="0.25" />
                    <stop offset="0.54" stopColor="gray" stopOpacity="0.12" />
                    <stop offset="1" stopColor="gray" stopOpacity="0.1" />
                </linearGradient>
                <linearGradient
                    id="b"
                    x1="540.17"
                    x2="540.17"
                    y1="180.2"
                    y2="130.75"
                    gradientTransform="translate(-63.92 7.85)"
                    xlinkHref="#a"
                />
                <linearGradient
                    id="c"
                    x1="540.17"
                    x2="540.17"
                    y1="140.86"
                    y2="82.43"
                    gradientTransform="rotate(-12.11 545.066 460.65)"
                    xlinkHref="#a"
                />
                <linearGradient
                    id="d"
                    x1="476.4"
                    x2="476.4"
                    y1="710.53"
                    y2="127.12"
                    xlinkHref="#a"
                />
                <linearGradient
                    id="e"
                    x1="476.94"
                    x2="476.94"
                    y1="156.13"
                    y2="106.68"
                    xlinkHref="#a"
                />
                <linearGradient
                    id="f"
                    x1="666.86"
                    x2="666.86"
                    y1="176.39"
                    y2="117.95"
                    xlinkHref="#a"
                />
            </defs>
            <path
                fill="#e0e0e0"
                d="M317.5 142.55H754.52V746.3700000000001H317.5z"
                transform="rotate(-12.11 160.03 1309.797)"
            />
            <path
                fill="url(#a)"
                d="M324.89 152.76H747.14V736.17H324.89z"
                opacity="0.5"
                transform="rotate(-12.11 160.03 1309.797)"
            />
            <path
                fill="#fafafa"
                d="M329.81 157.1H741.31V727.62H329.81z"
                transform="rotate(-12.11 159.585 1307.7)"
            />
            <path
                fill="url(#b)"
                d="M374.18 138.6H578.3199999999999V188.05H374.18z"
                transform="rotate(-12.11 100.28 1028.707)"
            />
            <path
                fill="url(#c)"
                d="M460.93 91.9c-15.41 3.31-25.16 18.78-21.77 34.55s18.62 25.89 34 22.58 25.16-18.78 21.77-34.55-18.59-25.89-34-22.58zm9.67 45.1a16.86 16.86 0 1112.56-20 16.66 16.66 0 01-12.56 20z"
                transform="translate(-189.92 -59.59)"
            />
            <path
                fill="#0071e0"
                d="M375.66 136.55H575.5V183.82000000000002H375.66z"
                transform="rotate(-12.11 99.61 1025.585)"
            />
            <path
                fill="#0071e0"
                d="M460.93 91.9a27.93 27.93 0 1033.17 21.45 27.93 27.93 0 00-33.17-21.45zm9.24 43.1a16.12 16.12 0 1112.38-19.14A16.12 16.12 0 01470.17 135z"
                transform="translate(-189.92 -59.59)"
            />
            <path fill="#e0e0e0" d="M257.89 116.91H694.91V720.73H257.89z" />
            <path fill="url(#d)" d="M265.28 127.12H687.53V710.53H265.28z" opacity="0.5" />
            <path fill="#fff" d="M270.65 131.42H682.15V701.9399999999999H270.65z" />
            <path fill="url(#e)" d="M374.87 106.68H579.01V156.13H374.87z" />
            <path
                fill="url(#f)"
                d="M666.86 118c-15.76 0-28.54 13.08-28.54 29.22s12.78 29.22 28.54 29.22 28.54-13.08 28.54-29.22S682.62 118 666.86 118zm0 46.08a16.86 16.86 0 1116.46-16.86A16.66 16.66 0 01666.86 164z"
                transform="translate(-189.92 -59.59)"
            />
            <path fill="#0071e0" d="M377.02 104.56H576.86V151.83H377.02z" />
            <path
                fill="#0071e0"
                d="M666.86 118a27.93 27.93 0 1027.93 27.93A27.93 27.93 0 00666.86 118zm0 44.05A16.12 16.12 0 11683 145.89 16.12 16.12 0 01666.86 162z"
                transform="translate(-189.92 -59.59)"
            />
            <g fill="#47e6b1" opacity="0.5">
                <path d="M15.27 737.05H19.03V758.38H15.27z" />
                <path
                    d="M205.19 796.65H208.95V817.98H205.19z"
                    transform="rotate(90 141.91 682.56)"
                />
            </g>
            <g fill="#47e6b1" opacity="0.5">
                <path d="M451.49 0H455.25V21.33H451.49z" />
                <path d="M641.4 59.59H645.16V80.92H641.4z" transform="rotate(90 578.125 -54.495)" />
            </g>
            <path
                fill="#4d8af0"
                d="M961 832.15a4.61 4.61 0 01-2.57-5.57 2.22 2.22 0 00.1-.51 2.31 2.31 0 00-4.15-1.53 2.22 2.22 0 00-.26.45 4.61 4.61 0 01-5.57 2.57 2.22 2.22 0 00-.51-.1 2.31 2.31 0 00-1.53 4.15 2.22 2.22 0 00.45.26 4.61 4.61 0 012.57 5.57 2.22 2.22 0 00-.1.51 2.31 2.31 0 004.15 1.53 2.22 2.22 0 00.26-.45 4.61 4.61 0 015.57-2.57 2.22 2.22 0 00.51.1 2.31 2.31 0 001.53-4.15 2.22 2.22 0 00-.45-.26z"
                opacity="0.5"
                transform="translate(-189.92 -59.59)"
            />
            <path
                fill="#fdd835"
                d="M326.59 627.09a4.61 4.61 0 01-2.57-5.57 2.22 2.22 0 00.1-.51 2.31 2.31 0 00-4.15-1.53 2.22 2.22 0 00-.26.45 4.61 4.61 0 01-5.57 2.57 2.22 2.22 0 00-.51-.1 2.31 2.31 0 00-1.53 4.15 2.22 2.22 0 00.45.26 4.61 4.61 0 012.57 5.57 2.22 2.22 0 00-.1.51 2.31 2.31 0 004.15 1.53 2.22 2.22 0 00.26-.45 4.61 4.61 0 015.57-2.57 2.22 2.22 0 00.51.1 2.31 2.31 0 001.53-4.15 2.22 2.22 0 00-.45-.26zM855 127.77a4.61 4.61 0 01-2.57-5.57 2.22 2.22 0 00.1-.51 2.31 2.31 0 00-4.15-1.53 2.22 2.22 0 00-.26.45 4.61 4.61 0 01-5.57 2.57 2.22 2.22 0 00-.51-.1 2.31 2.31 0 00-1.53 4.15 2.22 2.22 0 00.45.26 4.61 4.61 0 012.57 5.57 2.22 2.22 0 00-.1.51 2.31 2.31 0 004.15 1.53 2.22 2.22 0 00.26-.45 4.61 4.61 0 015.57-2.57 2.22 2.22 0 00.51.1 2.31 2.31 0 001.53-4.15 2.22 2.22 0 00-.45-.26z"
                opacity="0.5"
                transform="translate(-189.92 -59.59)"
            />
            <circle cx="812.64" cy="314.47" r="7.53" fill="#f55f44" opacity="0.5" />
            <circle cx="230.73" cy="746.65" r="7.53" fill="#f55f44" opacity="0.5" />
            <circle cx="735.31" cy="477.23" r="7.53" fill="#f55f44" opacity="0.5" />
            <circle cx="87.14" cy="96.35" r="7.53" fill="#4d8af0" opacity="0.5" />
            <circle cx="7.53" cy="301.76" r="7.53" fill="#47e6b1" opacity="0.5" />
        </svg>
    );
}

export default React.memo(EmptySuggestionsIcon);
